/**
 * @name constants
 * @description Core constants in ngx-responsive
 *
 * @license MIT
 */
export * from './linux.constants';
export * from './windows.constants';
export * from './tablet.constants';
export * from './mobile.constants';
export * from './os-systems.constants';
export * from './reg-expressions.constants';
export * from './game-devices.constants';
export * from './smart-tv.constants';
export * from './generic-bots.constants';
export * from './browser-names.constants';
export * from './ie-versions.constants';
export * from './user-agent.constants';
export * from './default-breackpoints.constants';

